import http from "../../core/services/http.service";

const SepaService = {
  getSepas(params = null) {
    return http.get('/api/v1/settlements/sepa/', {params});
  },
  getSepa(uuid, params) {
    return http.get(`/api/v1/settlements/sepa/${uuid}/`, {params});
  },
  createSepa(data) {
    return http.post('/api/v1/settlements/sepa/', data);
  },
  updateSepa(id, data, expand = '') {
    return http.put(`/api/v1/settlements/sepa/${id}/?expand=${expand}`, data);
  },
  generateSepa(data) {
    return http.post(`/api/v1/settlements/sepa/generate/`, data);
  },
  getDownloadUrl(sepa, type) {
    console.log({uuid: sepa.uuid, type});
    return http.get(`/api/v1/settlements/sepa/download/`, {params: {uuid: sepa.uuid, type}})
  },
  removeSepa(uuid) {
    return http.delete(`/api/v1/settlements/sepa/${uuid}/`)
  },
};

export default SepaService;
